const getCookie = (cookieName) => Object.assign({}, ...document.cookie
  .split('; ')
  .map((cookie) => {
    const [name, value] = cookie.split('=');
    return { [name]: value };
  }))[cookieName];

const setCookie = (name, value, expires, path = '/') => {
  (document.cookie = `${name}=${value};expires=${expires};path=${path}`);
};

const deleteCookie = (name, path = '/') => {
  document.cookie = `${name}=; path=${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export default { getCookie, setCookie, deleteCookie };
